import qs from 'qs';

import requestService from '../../../api/requestService';
import { mapAiIncident } from '../lib/mapAiIncident';
import type { AiIncidentId } from '../model/types';
import type { AiIncidentDto, ConvertAiIncidentToIncidentBody, CustomMeta } from './types';

export const aiIncidentsApi = {
  getAiIncidents: ({ eventId, page, pageSize }: { eventId: number; page: number; pageSize: number }) => {
    const query = qs.stringify(
      {
        filters: {
          event: eventId,
        },
        populate: '*',
        pagination: {
          page,
          pageSize,
        },
      },
      { encodeValuesOnly: true, skipNulls: true },
    );

    return requestService
      .get<CustomMeta<AiIncidentDto[]>>(`/ai-incidents${query ? `?${query}` : ''}`)
      .then((response) => ({
        ...response.data,
        data: response.data.data.map(mapAiIncident),
      }));
  },
  deleteAiIncident: (id: AiIncidentId) =>
    requestService.delete(`/ai-incidents/${id}`).then((response) => response.data),
  updateAiIncidentViewed: (id: AiIncidentId) =>
    requestService.put(`/ai-incidents/${id}`, { data: { isViewed: true } }).then((response) => response.data),
  convertAiIncidentToIncident: ({ id, data }: { id: AiIncidentId; data: ConvertAiIncidentToIncidentBody }) => {
    const { photoSources, ...incidentData } = data;
    const formData = new FormData();

    photoSources.forEach(({ source }) => {
      formData.append('files.photos', source, source.name);
    });
    formData.append('data', JSON.stringify(incidentData));

    return requestService
      .post(`/ai-incidents/${id}/convert-to-incident`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response) => response.data);
  },
};
